import ApiService from "@/services/api.service"

export const CalendarService = {
	calendarDictionaries() {
		return ApiService.get("calendar/dictionaries")
	},
	get(params) {
		return ApiService.get("records", params, { loader: params.loader })
	},
	doctors(branch_id, superadmin = false) {
		return ApiService.get(`${superadmin ? 'superadmin/' : ''}doctors/${branch_id}`)
	},
	createOrUpdateRecord(record) {
		return ApiService.post(`records/create`, record)
	},
	updateRecord(record, loader = true) {
		return ApiService.post(`records/${record.id}/update`, record, {}, { loader })
	},
	updateRecordNewVersion(recordId, data, loader = true) {
		return ApiService.post(`records/${recordId}/update/new`, data, {}, { loader })
	},
	cancelRecord(record_id, reason) {
		return ApiService.post(`records/${record_id}/cancel`, { reason: reason })
	},
	getAdditionalInfo(record_id) {
		return ApiService.get(`records/${record_id}/additional/info`)
	},
	loadRecordPopupDetails(record_id) {
		return ApiService.get(`records/${record_id}/popup/details`, {}, { loader: false })
	},
	recordAdditionalInfo(record_id, info) {
		return ApiService.post(`records/${record_id}/additional/record`, info)
	},
	recoverRecord(record_id) {
		return ApiService.post(`records/${record_id}/recover`)
	},
	copyRecord(record_id, params) {
		return ApiService.post(`records/${record_id}/copy`, params, {'Content-Type': 'multipart/form-data'})
	},
	updateRecordTeeth(record_id, teeth) {
		return ApiService.post(`records/${record_id}/update/teeth`, teeth)
	},
	updatePlanTreatment(treatment_id, params, loader = true) {
		return ApiService.post(`plan_treatments/${treatment_id}/update`, params, {}, { loader })
	},
	updatePlanTreatmentNew(treatment_id, params, loader = true) {
		return ApiService.post(`plan_treatments/${treatment_id}/update/new`, params, {}, { loader })
	},
	duplicatePlanTreatment(treatment_id) {
		return ApiService.post(`plan_treatments/${treatment_id}/duplicate`)
	},
	updatePlanTreatmentPrices(treatment_id) {
		return ApiService.post(`plan_treatments/${treatment_id}/prices/update`)
	},
	finishTask(id, status = '') {
		return ApiService.post(`task/${id}/finish`, { status })
	},
	finishTaskBulk(ids) {
		return ApiService.post(`task/finish/bulk`, { ids })
	},
	setRecordTiming(record_id, params) {
		return ApiService.post(`records/${record_id}/timing`, params)
	},
	initiateEGIZS(record_id) {
		return ApiService.post(`records/${record_id}/egisz/initiate`)
	},
	getEGISZList() {
		return ApiService.get(`egisz/list`)
	},
	getEGISZDictionaries(dictionary_type = null, superadmin = false) {
		return ApiService.get(`${superadmin ? 'superadmin/' : ''}records/egisz/dictionaries${dictionary_type ? '?dictionary_type='+dictionary_type : ''}`)
	},
	EGISZNextStep(record_id) {
		return ApiService.post(`records/${record_id}/egisz/nextStep`)
	},
	resetEGISZ(record_id) {
		return ApiService.post(`records/${record_id}/egisz/reset`)
	},
	validateEGISZ(record_id) {
		return ApiService.post(`records/${record_id}/egisz/validate`)
	},
	autoupdateEGIZS(record_id) {
		return ApiService.post(`records/${record_id}/egisz/autoupdate`)
	},
	getEgiszCDA(record_id) {
		return ApiService.get(`records/${record_id}/egisz/cda`)
	},
	getEgiszXML(record_id) {
		return ApiService.get(`records/${record_id}/egisz/xml`)
	},
	signCDA(record_id, params) {
		return ApiService.post(`records/${record_id}/egisz/signature`, params)
	},
	getStaffSchedule(params) {
		return ApiService.get("staff/schedule", params, { loader: params.loader })
	},
	fixStaffWorked(params) {
		return ApiService.post(`staff/period/fix`, params)
	},
	getPreviousVisits(recordId) {
		return ApiService.get(`patient/visits/${recordId}/previous`)
	},
	getPreviousVisit(recordId) {
		return ApiService.get(`patient/visits/previous/${recordId}`, {}, { loader: false })
	}
}
